var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('calendar',_vm._g({ref:"cal",class:{
    calendar: true,
    'job-calendar': true,
    'job-calendar--editable': _vm.editable,
  },attrs:{"events":_vm.events,"selected-date":_vm.daySelected,"selected-event":_vm.dateSelected,"split-days":_vm.splitDays,"editable":_vm.editable},on:{"date-clicked":_vm.dateClicked,"event-clicked":_vm.eventClicked,"drag-create-ended":_vm.dateClicked,"view-change":_vm.viewChanged,"created":function($event){_vm.calCreated = true}}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }